(function () {
  if (window.__enchlivingMobileCollectionInit) return;
  window.__enchlivingMobileCollectionInit = true;

  if (!customElements.get('enchliving-mobile-facets-bar')) {
    class EnchlivingMobileFacetsBar extends HTMLElement {}
    customElements.define('enchliving-mobile-facets-bar', EnchlivingMobileFacetsBar);
  }

  var COLS_STORAGE_KEY = 'enchliving:mobile-cols';
  var DEFAULT_COLS = '2';

  function readCols() {
    try {
      var v = localStorage.getItem(COLS_STORAGE_KEY);
      if (v === '1' || v === '2') return v;
    } catch (e) {}
    return DEFAULT_COLS;
  }

  function writeCols(value) {
    try { localStorage.setItem(COLS_STORAGE_KEY, value); } catch (e) {}
  }

  function applyCols(value) {
    document.querySelectorAll('product-list').forEach(function (list) {
      list.setAttribute('data-mobile-cols', value);
    });

    document.querySelectorAll('[data-enchliving-mobile-cols]').forEach(function (btn) {
      var isActive = btn.getAttribute('data-enchliving-mobile-cols') === value;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function initCols() {
    var current = readCols();
    applyCols(current);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-enchliving-mobile-cols]');
    if (!btn) return;
    e.preventDefault();
    var value = btn.getAttribute('data-enchliving-mobile-cols');
    if (value !== '1' && value !== '2') return;
    writeCols(value);
    applyCols(value);
  });

  document.addEventListener('facet:updated', function () {
    applyCols(readCols());
    syncMobileExclusiveCheckbox();
  });

  function updateMobileFilterCount() {
    document.querySelectorAll('enchliving-mobile-facets-bar[data-section-id]').forEach(function (bar) {
      var sectionId = bar.getAttribute('data-section-id');
      var forms = document.querySelectorAll('form#facet-form[section-id="' + sectionId + '"] , form[is="facet-form"][section-id="' + sectionId + '"]');
      if (!forms || forms.length === 0) {
        forms = document.querySelectorAll('form#facet-form, form[is="facet-form"]');
      }

      var formsArray = Array.from(forms);
      var active = 0;
      if (typeof window.enchlivingCountActiveFilters === 'function') {
        active = window.enchlivingCountActiveFilters(formsArray);
      } else {
        active = 0;
        formsArray.forEach(function (form) {
          active += form.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked').length;
          var priceGte = form.querySelector('input[name="filter.v.price.gte"]');
          var priceLte = form.querySelector('input[name="filter.v.price.lte"]');
          if ((priceGte && priceGte.value) || (priceLte && priceLte.value)) active += 1;
        });
      }

      var btn = bar.querySelector('.enchliving-mobile-facets-scroll__filter-btn');
      if (!btn) return;
      var span = btn.querySelector('.enchliving-mobile-facets-scroll__count');
      if (active > 0) {
        if (span) span.textContent = '(' + active + ')';
        else {
          span = document.createElement('span');
          span.className = 'enchliving-mobile-facets-scroll__count';
          span.textContent = '(' + active + ')';
          btn.appendChild(span);
        }
      } else if (span) {
        span.remove();
      }
    });
  }

    window.enchlivingCountActiveFilters = function enchlivingCountActiveFilters(formsArg) {
      var formsList = Array.isArray(formsArg) && formsArg.length ? formsArg : null;

      if (!formsList) {
        try {
          var chips = Array.from(document.querySelectorAll('.active-facets .removable-facet'));
          if (chips.length > 0) {
            var labels = new Set();
            chips.forEach(function (chip) {
              var text = (chip.textContent || '').replace(/\s+/g, ' ').trim();
              if (!text) return;
              var after = text.indexOf(':') !== -1 ? text.split(':').pop().trim() : text;
              if (after) labels.add(after);
            });
            if (labels.size > 0) return labels.size;
          }
        } catch (e) {
        }
      }

      try {
        var unique = new Set();
        var forms = formsList || Array.from(document.querySelectorAll('form#facet-form, form[is="facet-form"]'));
        forms.forEach(function (form) {
          try {
            var fd = new FormData(form);
            for (var pair of fd.entries()) {
              var key = pair[0];
              var value = pair[1];
              if (!key) continue;
              if (key === 'sort_by') {
                if (value !== '' && value != null) unique.add('sort_by|' + String(value));
                continue;
              }
              if (key.indexOf('filter.') !== 0) continue;
              if (value === '' || value == null) continue;
              if (key === 'filter.v.price.gte' || key === 'filter.v.price.lte') {
                unique.add('filter.v.price');
              } else {
                unique.add(key + '|' + String(value));
              }
            }
          } catch (err) {
            form.querySelectorAll('input[type="checkbox"]:checked, input[type="radio"]:checked').forEach(function (inp) {
              var n = inp.name || inp.getAttribute('name') || '';
              if (!n) return;
              var v = inp.value || 'on';
              if (n === 'sort_by') unique.add('sort_by|' + String(v));
              else if (n.indexOf('filter.') === 0) {
                if (n === 'filter.v.price.gte' || n === 'filter.v.price.lte') unique.add('filter.v.price'); else unique.add(n + '|' + String(v));
              }
            });
            var select = form.querySelector('select[name="sort_by"]');
            if (select && select.value) unique.add('sort_by|' + select.value);
            var priceGte = form.querySelector('input[name="filter.v.price.gte"]');
            var priceLte = form.querySelector('input[name="filter.v.price.lte"]');
            if ((priceGte && priceGte.value) || (priceLte && priceLte.value)) unique.add('filter.v.price');
          }
        });
        return unique.size;
      } catch (e) {
        return 0;
      }
    };

  document.addEventListener('facet:updated', updateMobileFilterCount);
  document.addEventListener('facet:update', function () { setTimeout(updateMobileFilterCount, 220); });
  document.addEventListener('swym:collections-loaded', function () { setTimeout(updateMobileFilterCount, 160); });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('form#facet-form, form[is="facet-form"]')) {
      setTimeout(updateMobileFilterCount, 40);
    }
  });

  var EXCLUSIVE_STORAGE_KEY = 'enchliving:online-store-only';
  var EXCLUSIVE_BODY_CLASS = 'enchliving-online-store-only';

  function syncMobileExclusiveCheckbox() {
    var active = false;
    try {
      active = localStorage.getItem(EXCLUSIVE_STORAGE_KEY) === '1';
    } catch (e) {
      active = document.body.classList.contains(EXCLUSIVE_BODY_CLASS);
    }

    document.querySelectorAll('[data-enchliving-mobile-exclusive-toggle]').forEach(function (chk) {
      if (chk.checked !== active) chk.checked = active;
    });

    document.querySelectorAll('[data-enchliving-exclusive-option]').forEach(function (btn) {
      var mode = btn.getAttribute('data-enchliving-exclusive-option');
      var isThisActive = mode === 'online' ? active : !active;
      btn.classList.toggle('is-active', isThisActive);
      btn.setAttribute('aria-pressed', isThisActive ? 'true' : 'false');
    });
  }

  function initExclusiveSync() {
    var isCollection = document.body.getAttribute('data-page-type') === 'collection';
    var saved = '0';
    try { saved = localStorage.getItem(EXCLUSIVE_STORAGE_KEY) || '0'; } catch (e) {}
    if (saved === '1' && isCollection) {
      document.body.classList.add(EXCLUSIVE_BODY_CLASS);
    }
    syncMobileExclusiveCheckbox();
  }

  function boot() {
    initCols();
    initExclusiveSync();
    updateMobileFilterCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
